import { useMemo } from "react"

import { Box } from "components/shared/box"

import { groupArrayItems } from "utils/group-array-items"

import type { StatItemData } from "./stat-item"
import { StatItem } from "./stat-item"

type StatsProps = {
  mainStats: StatItemData[]
  secondaryStats: StatItemData[]
}

export function Stats({ mainStats, secondaryStats }: StatsProps) {
  const groupedMainStats = useMemo(() => groupArrayItems<StatItemData>(mainStats, 2), [mainStats])
  const groupedSecondaryStats = useMemo(() => groupArrayItems<StatItemData>(secondaryStats, 2), [secondaryStats])

  return (
    <Box>
      {/* TODO padding */}
      <Box row className={`flex flex-wrap lg:border-b-[1px] lg:border-[#FFFFFF33] lg:pb-2`}>
        {groupedMainStats.map((group, i) => (
          <Box row className={`flex w-full gap-3 lg:gap-10`} key={`${group[0].label}-${i}`}>
            {group.map(({ imgUrl, label, value }, id) => (
              <StatItem key={id} label={label} value={value} imgUrl={imgUrl} uppercase mb={"mb-2 lg:mb-4"} />
            ))}
          </Box>
        ))}
      </Box>
      <Box row className={`flex flex-wrap lg:mt-6`}>
        {groupedSecondaryStats.map((group, i) => (
          <Box row className={`flex w-full gap-3 lg:gap-10`} key={`${group[0].label}-${i}`}>
            {group.map(({ label, value }, id) => (
              <StatItem
                key={id}
                label={label}
                value={value}
                mb={i !== groupedSecondaryStats.length - 1 ? "mb-0 lg:mb-2" : "mb-2 lg:mb-0"}
              />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
